import { createFileRoute, notFound } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { agreementSectionFromSlug } from '@/lib/agreement-sections';
import { AgreementTypeOverviewPage } from '@/features/section-overview/agreement-sections';

/**
 * One service-agreement sales type's overview (`/overview/service-agreement/new-car`,
 * `/used-car`, `/prolonging`), opened from its sidebar entry. Core like the section overviews;
 * each card on it is gated on the list it is.
 */
export const Route = createFileRoute('/_app/overview/service-agreement/$agreementType')({
  staticData: { featureKey: 'section-overview' },
  beforeLoad: async ({ context, location, params }) => {
    if (!agreementSectionFromSlug(params.agreementType)) {
      throw notFound();
    }
    await requireFeature(context, location, { feature: 'section-overview' });
  },
  component: Overview,
});

function Overview() {
  const type = agreementSectionFromSlug(Route.useParams().agreementType);
  // Keyed so switching type starts each card from its own state.
  return type ? <AgreementTypeOverviewPage key={type} type={type} /> : null;
}
